import { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { PublicRoutes } from "./PublicRoutes";
import { MainLayout } from "../pages/layouts/MainLayout";
import {
  DashoardPage,
  LoginPage,
  ConfigurationPage,
  // SecurityConfigurationPage,
  NewConfigurationPage,
  InitialBankConfigurationPage,
  DetailConfigurationPage,
  MappedFieldPage,
  DetailMappedFieldPage,
  NewMappedFieldPage,
  AdminQuicklinksPage,
  AdminProductPage,
  ProductConfigurationPage,
  AdminTransactionPage,
  TransactionConfigurationPage,
  AdminTranslationPage,
  NewTranslationPage,
  IuviMarketingAdminPage,
  AdminWidgetsPage,
  AdminAgentsPage,
  NewAgentPage,
  AdminTenantsPage,
  TenantConfigurationPage,
  AdminApplicationsPage,
  ApplicationsConfigurationPage,
  EnvExportPage,
  EnvImportPage,
  AdminVersionPage,
  AdminUsersPage,
  DetailUserPage,
  NewUserPage,
  AdminConsoleTranslationPage,
  AdminPointsPage,
  DetailPointsPage,
  NewServicePointsPage,
  NewMasterPointsPage,
  NewPointOfAttentionPage,
  AdminCataloguePage,
  NewProtocolsPage,
  AdminRolesPage,
  NewRolesPage,
  ImportPage,
  ErrorLabelsPage,
  ErrorEnvImportPage,
  AuditoryReportPage,
} from "../pages";
import { AppContext } from "../context/index";
import { NewApplicationPage } from "../pages/applications/NewApplicationPage";
import { ValidationMessagesPage } from "../pages/validationmessages/ValidationMessagesPage";
import { NewValidationMessagesPage } from "../pages/validationmessages/NewValidationMessagesPage";
import { NewSchedulesPage } from "../pages/points/NewSchedulesPage";
import { NewConfirmationMessagesPage } from "../pages/confirmationmessages/NewConfirmationMessagesPage";
import { ConfirmationMessagesPage } from "../pages/confirmationmessages/ConfirmationMessagesPage";
import { DownloadGeneralPage } from "../pages/points/DownloadGeneralPage";
import { NewTenantPage } from "../pages/tenants/NewTenantPage";
import { NewConsoleTranslation } from "../pages/consoletranslations/NewConsoleTranslation";
import { NewQuickLink } from "../pages/quicklinks/NewQuicklink";
import { NewCampaignPage } from "../pages/iuvimarketing/NewCampaignPage";
import { NewProductPage } from "../pages/products/NewProductPage";
import { NewProperty } from "../components/shared/NewProperty";
import { NewTransactionPage } from "../pages/transactions/NewTransactionPage";
import { SelectApplicationPage } from "../pages/selectapplication/SelectApplicationPage";
import { AdminPermissionPage } from "../pages/permissions/AdminPermissionPage";
import { NewPermissionPage } from "../pages/permissions/NewPermissionPage";
import { AdminFunctionalityPage } from "../pages/functionalities/AdminFunctionalityPage";
import { NewFunctionalityPage } from "../pages/functionalities/NewFunctionalityPage";
import { ViewTenantConfigurationPage } from "../pages/tenants/ViewTenantConfigurationPage";
import { DetailRolePage } from "../pages/users/DetailRolePage";

export const AppRouter = () => {
  const {
    appState: { user },
  } = useContext(AppContext);

  return (
    <Router>
      <Routes>
        <Route
          key="login"
          path="/login"
          element={
            <PublicRoutes>
              <LoginPage />
            </PublicRoutes>
          }
        />
        {sessionStorage.getItem("IS::FIRST::ENTRY") ? (
          <Route key="mr" path="/" element={<MainLayout />}>
            <Route key="dash" index={true} element={<DashoardPage />} />
          </Route>
        ) : (
          <Route key="mr" path="/" element={<MainLayout />}>
            <Route key="dash" index={true} element={<DashoardPage />} />
            <Route key="configurations" path="configurations">
              <Route
                key="info"
                path="initialbankInfo"
                element={<InitialBankConfigurationPage />}
              />
              {[
                "globalConfiguration",
                "serverEndpoint",
                "fieldValidations",
                "mobile",
                "iuvimarketing",
                "iuvinow",
                "iuvisales",
                "iuviprofiler",
                "findmybank",
                "administrative",
                "security",
              ].map((path) => {
                if (path === "iuvimarketing") {
                  return (
                    <Route key={path} path={path}>
                      <Route
                        key="index"
                        index={true}
                        element={<IuviMarketingAdminPage />}
                      />
                      <Route
                        key="new"
                        path="new"
                        element={<NewCampaignPage />}
                      />
                      <Route
                        key="edit"
                        path="edit"
                        element={<NewCampaignPage update={true} />}
                      />
                    </Route>
                  );
                } else {
                  return (
                    <Route key={path} path={path}>
                      <Route
                        key="index"
                        index={true}
                        element={<ConfigurationPage />}
                      />
                      <Route
                        key="detail"
                        path="detail"
                        element={<DetailConfigurationPage />}
                      />
                      <Route
                        key="new"
                        path="new"
                        element={<NewConfigurationPage />}
                      />
                      <Route
                        key="edit"
                        path="edit"
                        element={<NewConfigurationPage update={true} />}
                      />
                    </Route>
                  );
                }
              })}
              <Route key="*" path="*" element={<Navigate to="/" />} />
            </Route>
            <Route path="translations">
              <Route
                key="index"
                index={true}
                element={<AdminTranslationPage />}
              />
              <Route key="new" path="new" element={<NewTranslationPage />} />
              <Route
                key="edit"
                path="edit"
                element={<NewTranslationPage update={true} />}
              />
              <Route
                key="detail"
                path="detail"
                element={<NewTranslationPage detail={true} />}
              />
              <Route path="import">
                <Route
                  key="import"
                  index={true}
                  element={<ImportPage />}
                />
                <Route
                  key="errorimport"
                  path="errorimport"
                  element={<ErrorLabelsPage />}
                />
              </Route>
            </Route>
            <Route key="mpfields" path="mappedfields">
              <Route key="index" index={true} element={<MappedFieldPage />} />
              <Route
                key="detail"
                path="detail"
                element={<DetailMappedFieldPage />}
              />
              <Route key="new" path="new" element={<NewMappedFieldPage />} />
              <Route
                key="edit"
                path="edit"
                element={<NewMappedFieldPage update={true} />}
              />
            </Route>
            <Route key="qlinks" path="quicklinks">
              <Route
                key="index"
                index={true}
                element={<AdminQuicklinksPage />}
              />
              <Route key="new" path="new" element={<NewQuickLink />} />
              <Route key="edit" path="edit" element={<NewQuickLink update={true} />} />
            </Route>
            <Route
              key="widgets"
              path="widgets"
              element={<AdminWidgetsPage />}
            />
            <Route key="products" path="products">
              <Route key="index" index={true} element={<AdminProductPage />} />
              <Route
                key="new"
                path="new"
                element={<NewProductPage />}
              />
              <Route
                key="newproperty"
                path="newproperty"
                element={<NewProperty type="product"/>}
              />
              <Route
                key="editproperty"
                path="editproperty"
                element={<NewProperty type="product" update={true} />}
              />
              <Route
                key="configuration"
                path="configuration"
                element={<ProductConfigurationPage />}
              />
            </Route>
            <Route key="transactions" path="transactions">
              <Route key="index" index={true} element={<AdminTransactionPage />}/>
              <Route
                key="new"
                path="new"
                element={<NewTransactionPage />}
              />
              <Route
                key="newproperty"
                path="newproperty"
                element={<NewProperty type="transaction"/>}
              />
              <Route
                key="editproperty"
                path="editproperty"
                element={<NewProperty type="transaction" update={true} />}
              />
              <Route
                key="configuration"
                path="configuration"
                element={<TransactionConfigurationPage />}
              />
            </Route>
            <Route key="pointsofattention" path="pointsofattention">
              <Route key="index" index={true} element={<AdminPointsPage />} />
              <Route key="newpointofattention" path="newpointofattention" element={<NewPointOfAttentionPage />} />
              <Route key="editmultiplepointofattention" path="editpointofattention" element={<NewPointOfAttentionPage update={true} />} />
              <Route key="editmultiplepointofattention" path="editmultiplepointofattention" element={<NewPointOfAttentionPage updateMultiple={true} />} />
              <Route key="detailpointofattention" path="detailpointofattention" element={<DetailPointsPage />} />
              <Route key="downloadgeneral" path="downloadgeneral" element={<DownloadGeneralPage />} />
              <Route key="newservice" path="newservice" element={<NewServicePointsPage />} />
              <Route
                key="editservice"
                path="editservice"
                element={<NewServicePointsPage update={true} />}
              />
              <Route key="newschedule" path="newschedule" element={<NewSchedulesPage />} />
              <Route
                key="editschedule"
                path="editschedule"
                element={<NewSchedulesPage update={true} />}
              />
              <Route key="newmaster" path="newmaster" element={<NewMasterPointsPage />} />
              <Route
                key="editmaster"
                path="editmaster"
                element={<NewMasterPointsPage update={true} />}
              />
            </Route>
            <Route key="catalogue" path="catalogue">
              <Route key="index" index={true} element={<AdminCataloguePage />} />
              <Route key="newprotocols" path="newprotocols" element={<NewProtocolsPage />} />
              <Route key="editprotocols" path="editprotocols" element={<NewProtocolsPage update={true} />} />
              <Route key="cloneprotocols" path="cloneprotocols" element={<NewProtocolsPage clone={true} />} />
            </Route>
            <Route key="roles" path="adminroles">
              <Route key="index" index={true} element={<AdminRolesPage />} />
              <Route key="newroles" path="newroles" element={<NewRolesPage />} />
              <Route key="editroles" path="editroles" element={<NewRolesPage update={true} />} />
              <Route key="cloneroles" path="cloneroles" element={<NewRolesPage clone={true} />} />
              <Route key="detailroles" path="detailroles" element={<NewRolesPage detail={true} />} />
            </Route>
            <Route key="agents" path="agents">
              <Route key="index" index={true} element={<AdminAgentsPage />} />
              <Route key="new" path="new" element={<NewAgentPage />} />
              <Route key="edit" path="edit" element={<NewAgentPage update={true} />} />
            </Route>
            <Route key="applications" path="applications">
              <Route
                key="index"
                index={true}
                element={<AdminApplicationsPage />}
              />
              <Route key="new" path="new" element={<NewApplicationPage />} />
              <Route key="edit" path="edit">
                <Route
                  key="index"
                  index={true}
                  element={<ApplicationsConfigurationPage />}
                />
                <Route key="export" path="export" element={<EnvExportPage />} />
                <Route path="import">
                  <Route
                    key="import"
                    index={true}
                    element={<EnvImportPage />}
                  />
                  <Route
                    key="errorimport"
                    path="errorimport"
                    element={<ErrorEnvImportPage />}
                  />
                </Route>
              </Route>
            </Route>
            <Route key="tenants" path="tenants">
              <Route key="index" index={true} element={<AdminTenantsPage />} />
              <Route key="new" path="new" element={<NewTenantPage />} />
              <Route
                key="edit"
                path="edit"
                element={<TenantConfigurationPage />}
              />
              <Route
                key="view"
                path="view"
                element={<ViewTenantConfigurationPage />}
              />
            </Route>
            <Route key="versions" path="versions">
              <Route key="index" index={true} element={<AdminVersionPage />} />
            </Route>
            <Route key="consoletranslations" path="consoletranslations">
              <Route
                key="index"
                index={true}
                element={<AdminConsoleTranslationPage />}
              />
              <Route key="new" path="new" element={<NewConsoleTranslation />} />
              <Route key="edit" path="edit" element={<NewConsoleTranslation update={true} />} />
            </Route>
            <Route key="users" path="users">
              <Route key="index" index={true} element={<AdminUsersPage />} />
              <Route key="detail" path="detail" element={<DetailUserPage />} />
              <Route key="new" path="new" element={<NewUserPage />} />
              <Route
                key="edit"
                path="edit"
                element={<DetailUserPage update={true} />}
              />
              <Route
                key="detail-rol"
                path="detail-rol"
                element={<DetailRolePage />}
              />
            </Route>
            <Route path="confirmationmessages">
              <Route
                key="index"
                index={true}
                element={<ConfirmationMessagesPage />}
              />
              <Route
                key="edit"
                path="edit"
                element={<NewConfirmationMessagesPage update={true} />}
              />
            </Route>
            <Route path="validationmessages">
              <Route
                key="index"
                index={true}
                element={<ValidationMessagesPage />}
              />
              <Route
                key="edit"
                path="edit"
                element={<NewValidationMessagesPage update={true} />}
              />
            </Route>
            <Route key="permissions" path="permissions">
              <Route key="index" index={true} element={<AdminPermissionPage />} />
              <Route key="newpermissions" path="newpermissions" element={<NewPermissionPage />} />
              <Route key="detailpermissions" path="detailpermissions" element={<NewPermissionPage detail={true} />} />
              <Route key="editpermissions" path="editpermissions" element={<NewPermissionPage update={true} />} />
              <Route key="clonepermissions" path="clonepermissions" element={<NewPermissionPage clone={true} />} />
            </Route>
            <Route key="functionalities" path="functionalities">
              <Route key="index" index={true} element={<AdminFunctionalityPage />} />
              <Route key="newfunctionalities" path="newfunctionalities" element={<NewFunctionalityPage />} />
              <Route key="detailfunctionalities" path="detailfunctionalities" element={<NewFunctionalityPage detail={true} />} />
              <Route key="editfunctionalities" path="editfunctionalities" element={<NewFunctionalityPage update={true} />} />
              <Route key="clonefunctionalities" path="clonefunctionalities" element={<NewFunctionalityPage clone={true} />} />
            </Route>
            <Route path="selectapplication">
              <Route
                key="index"
                index={true}
                element={<SelectApplicationPage />}
              />
            </Route>
            <Route path="auditreport">
              <Route
                key="index"
                index={true}
                element={<AuditoryReportPage />}
              />
            </Route>
          </Route>
        )}

        <Route
          key="**"
          path="*"
          element={<Navigate to={user ? "/" : "/login"} />}
        />
      </Routes>
    </Router>
  );
};
